import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

const { FlexPane, AbsolutePane, ImageButton, Text } = MojitoPresentation.Components;
const { actions: notificationsActions } = MojitoServices.SportsContent.ContentNotifications;

const SubscribeEventsOnboarding = ({ mojitoTools: { config, stringResolver } }) => {
    const dispatch = useDispatch();
    const onClick = useCallback(
        () => dispatch(notificationsActions.acknowledgeOnboarding()),
        [dispatch]
    );

    return (
        <FlexPane config={config.container}>
            <AbsolutePane config={config.closeButtonWrapper}>
                <ImageButton config={config.closeButton} onClick={onClick} />
            </AbsolutePane>
            <Text config={config.description}>
                {stringResolver.resolveString('$SUBSCRIBE_EVENTS_ONBOARDING.DESCRIPTION')}
            </Text>
        </FlexPane>
    );
};

export default SubscribeEventsOnboarding;
